import useCurrentBrand from 'Hooks/useCurrentBrand';
import useScreen from "Hooks/useScreen";
import { NAV_BAR_HEIGHT_MOBILE, TOP_BAR_HEADER_FOOTER_HEIGHT } from "modules/Const";
import { styx, clsx } from "modules/Utils";
import { CSSProperties, ReactNode } from "react";
import ContentSymphony from "../components/shareable/ContentSymphony";

interface PageSymphonyProps {
    className: string;
    style?: CSSProperties;
    styleContent?: CSSProperties;
    isProMobileNavCta?: boolean;
    isContent?: boolean;
    isStepper?: boolean;
    isCard?: boolean;
    maxWidth?: number;
    children?: ReactNode;
}

const PageSymphony = ({
    className,
    style,
    styleContent,
    isProMobileNavCta = false,
    isContent = false,
    isStepper = false,
    isCard = false, // NOTE: rarely used
    maxWidth = 1200,
    children,
}: PageSymphonyProps) => {
    const {
        mobileView,
        mStyle,
        cssCalc
    } = useScreen();
    const { isProBrand } = useCurrentBrand();

    return (
        <div
            className={clsx('pageSymphonyElement', className)}
            style={styx(
                mStyle(sty, 'pageSymphonyElement'),
                isStepper && {
                    overflowY: 'scroll',
                    height: cssCalc(TOP_BAR_HEADER_FOOTER_HEIGHT + (mobileView ? 29 : 0))
                },
                style,
                mobileView && !isProBrand && isProMobileNavCta && { marginBottom: NAV_BAR_HEIGHT_MOBILE },
            )}
        >
            {isContent ?
                <ContentSymphony
                    isCard={isCard}
                    style={styx(
                        { maxWidth },
                        styleContent
                    )}
                >
                    {children}
                </ContentSymphony>
                :
                children
            }
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    pageSymphonyElement: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 24,
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24,
        width: '100%',
        marginBottom: 0,
    },
    pageSymphonyElement_mobile: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
    },
}

export default PageSymphony;